export enum WSO2AuthLocalStorageNames {
  IdToken = 'id_token',
  AccessToken = 'access_token',
  RedirectUri = 'redirectUri',
  authorizationCode = 'code',
}
